module.exports = "up-circle-arrow-full"